/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {create} from 'zustand';
import Time from 'toolbox/time';

const useUIGeneratorState = create((set, get) => ({
    uiElements: {},
    addNewUIElement: (uiId, type, content, onClose, settings) => {
        set(state => {
            let uiElements = state.uiElements
            uiElements[uiId] = {
                uiId,
                type,
                content,
                onClose,
                settings,
                openTime: Time.now(),
                state: {}
            }
            return {uiElements: uiElements}
        })
    },
    removeUIElement: (uiId) =>
        set(state => {
            const element = state.uiElements[uiId];
            if (element?.onClose) {
                element.onClose({inputState: element.state});
            }
            const {[uiId]: removedElement, ...restElements} = state.uiElements;
            return {uiElements: restElements};
        }),

    updateUIElementState: (uiId, newState) => set(state => ({
        uiElements: {
            ...state.uiElements,
            [uiId]: {
                ...state.uiElements[uiId],
                state: {
                    ...state.uiElements[uiId].state,
                    ...newState
                }
            }
        }
    })),

    getUIElement: (uiId) => get().uiElements[uiId],

    getAllUIElements: () => get().uiElements,
    isTopElement: (uiId) => {
        let sortedUiIds = get().getSortedIds()
        return sortedUiIds.length > 0 && sortedUiIds[sortedUiIds.length - 1] === uiId;
    },
    getSortedIds: () => {
        const elementsArray = Object.values(get().uiElements);
        elementsArray.sort((a, b) => a.openTime - b.openTime);
        const ids = elementsArray.map(item => item.uiId);
        // Only display the 100 newest UI elements
        return ids.slice(Math.max(ids.length - 100, 0));
    },

    clearAllUIElements: () => set({uiElements: {}}),
}));

export const getUIGeneratorStore = () => useUIGeneratorState.getState()

export default useUIGeneratorState;
